import { render } from "./Calldrip.vue?vue&type=template&id=63fb81f2&scoped=true&ts=true"
import script from "./Calldrip.vue?vue&type=script&lang=ts"
export * from "./Calldrip.vue?vue&type=script&lang=ts"

import "./Calldrip.vue?vue&type=style&index=0&id=63fb81f2&scoped=true&lang=css"

import exportComponent from "C:\\Jenkins\\workspace\\Mock_develop\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fb81f2"]])

export default __exports__